import { DirectoryFormSchema } from "../../schemas/forms";
import { directories } from "../../api/directories.service";
import type { Directory } from "../../api/directories.service";
import { researchCms } from "../../api/researchCms.service";
import type { HierarchyManagerConfig } from "../../components/HierarchyManager";

export const directoryConfig: HierarchyManagerConfig<Directory> = {
  title: "Directories",
  singularName: "Directory",
  pluralName: "Directories",

  apiService: {
    getAll: directories.getAll,
    getById: (id: string) => directories.getById(id),
    create: async (data: Record<string, unknown>) => {
      const directory = await directories.create(data as Parameters<typeof directories.create>[0]);
      await researchCms
        .createPublicationConfig({ directoryId: directory.id, templateType: "conventional" })
        .catch(() => undefined);
      return directory;
    },
    update: (id: string, data: Record<string, unknown>) =>
      directories.update(id, data as Parameters<typeof directories.update>[1]),
    delete: (id: string) => directories.delete(id),
    move: (id: string, parentId: string | null) => directories.move(id, parentId),
  },

  formFields: [
    {
      name: "parentId",
      label: "Parent Directory",
      type: "select",
      required: false,
      searchable: true,
      defaultValue: null,
    },
    {
      name: "name",
      label: "Name",
      type: "text",
      required: true,
      placeholder: "Enter directory name",
      defaultValue: "",
    },
    {
      name: "code",
      label: "Code",
      type: "text",
      required: true,
      placeholder: "Enter directory code",
      defaultValue: "",
    },
    {
      name: "displayOrder",
      label: "Display Order",
      type: "number",
      required: false,
      defaultValue: 0,
      helperText: "Lower numbers appear first",
    },
  ],

  validationSchema: DirectoryFormSchema,

  enableDragAndDrop: true,
  enableSearch: true,
  enableBreadcrumbs: true,
  showCode: true,
};
